
import React from 'react';
import { ContextBar } from './ContextBar';
import { useSal } from '../contexts/SalContext';

export const ControlsPanel: React.FC = () => {
  const { context, setContext, safeConfig, setConfig, orders, drivers, viewMode } = useSal();

  if (viewMode === 'analytics') return null;

  return (
    <ContextBar 
      context={context} 
      setContext={setContext} 
      config={safeConfig} 
      setConfig={setConfig}
      orders={orders} 
      drivers={drivers} 
    />
  );
};
